import {
    Container,
    Grid,
} from "@mui/material";
import SubscriptionItem from "../components/SubscriptionItem";
import {SubscriptionPageInfo} from "../../../constants/SubscriptionConstants";

export default function Subscriptions() {
    return (
        <Container maxWidth="xl" sx={{pt: 2}}>
            <Grid container spacing={2}>
                {
                    SubscriptionPageInfo.map(i => (
                        <SubscriptionItem key={i.type} {...i} />
                    ))
                }
            </Grid>
        </Container>
    );
}
